import base from 'stores/search-base/mutations';
import * as types from './mutation-types';

export default {
  ...base,
  [types.UPDATE_RESULT_ROW](state, { id, data }) {
    if (state.results.hits) {
      const i = state.results.hits.findIndex((r) => r.id === id);

      if (i > -1) {
        Object.keys(data).forEach((fieldKey) => {
          state.results.hits[i][fieldKey] = data[fieldKey];
        });
      }
    }
  }
};
